// extracted by mini-css-extract-plugin
export default {"component":"page_component__1O9hc","title":"page_title__pJFmX","mainTitle":"page_mainTitle__mHIPf","subTitle":"page_subTitle__y+Mwe","btn":"page_btn__O8h2f"};